module.exports = __webpack_public_path__ + "img/refund.add6bf6e.svg";